import axios from "axios";
import {EmployeeDocumentTypeInterface} from "../redux/employee-document-type/employeeDocument.type";

/**
 * Create employee document type.
 *
 * @param data
 */
async function createEmployeeDocumentTypeApi(data: EmployeeDocumentTypeInterface) {
    return axios({
        method: 'POST',
        url: '/api/v1/employee-documents-types',
        data: data
    });
}

/**
 * Get employee document types.
 */
async function getEmployeeDocumentTypesApi() {
    return axios({
        method: 'GET',
        url: '/api/v1/employee-documents-types',
    });
}

export {
    createEmployeeDocumentTypeApi,
    getEmployeeDocumentTypesApi,
}
